import * as React from 'react';

import OfferBannerDetailsQuote from '../../details/quote/OfferBannerDetailsQuote';

import type { SubcampaignOffer } from 'types';

type Props = {
  offer: SubcampaignOffer,
  renderExpiredText: () => React.ReactNode,
  renderDescriptionText: () => React.ReactNode
};

const OfferBannerRevokedQuote: React.FC<Props> = ({
  offer,
  renderExpiredText,
  renderDescriptionText
}) => (
  <div className="offer-banner-revoked-quote">
    <OfferBannerDetailsQuote
      offer={offer}
      textStyle="disabled"
    />
    {renderExpiredText()}
    {renderDescriptionText()}
  </div>
);

export default OfferBannerRevokedQuote;
